import React from "react";
import { Field, reduxForm } from "redux-form";
import { Button, Col, Row } from "antd";
import { renderField } from "utils/forms";

let StudentCurrentJob = props => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col span={12}>
          <Field
            label="Current Position"
            name="current_position"
            component={renderField}
            type="string"
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Field
            label="Current Company"
            name="current_company"
            component={renderField}
            type="string"
          />
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Button
            style={{
              width: "100%"
            }}
            type="primary"
            htmlType="submit"
          >
            Save
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default reduxForm({
  form: "studentCurrentJob"
})(StudentCurrentJob);



// WEBPACK FOOTER //
// ./src/components/dashboard/student/forms/current-job.js